var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ReportTitle',{attrs:{"tripId":_vm.tripReport.tripReportId,"tripName":_vm.tripReport.name,"tripBeginDt":_vm.tripReport.beginDt,"tripEndDt":_vm.tripReport.endDt,"privacySetting":_vm.tripReport.privacy,"locale":_vm.locale}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }